import React, { Component } from 'react';
import { compose } from 'recompose';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import Subheader from 'material-ui/Subheader';
import muiTheme from 'helpers/muiTheme';

import LoginPage from 'components/login/LoginPage';
import CmsApp from './CmsApp'

import AppStyle from './AppStyle';
import SnackBar from 'store/snackbar/SnackBar';
import { withAuth } from 'store/auth/withAuth';
import { withPreferences } from 'store/preferences/withPreferences';

import '../../assets/font-awesome-4.6.3/css/font-awesome.min.css';
import '../../assets/semantic/dist/semantic.min.css';

const CmsWrapper = compose(
  withAuth(),
  withPreferences(),
)(
  ({
    user,
    children,
    preferences,
    observeForAuthStatus,
    fetchPreferencesStatus,
  }) => {
    if (
      observeForAuthStatus.isRequest ||
      fetchPreferencesStatus.isRequest
    ) {
      return (
        <div style={AppStyle.startingWrapper}>
          <div style={AppStyle.startingContent}>
            <div style={AppStyle.indicatorWrapper}>
              <RefreshIndicator
                status="loading"
                size={80}
                left={100}
                top={0}
              />
            </div>
            <Subheader style={{ padding: 0, textAlign: 'center' }}>
              Initializing CMS...
            </Subheader>
          </div>
        </div>
      );
    } else if (observeForAuthStatus.isFailure) {
      return (
        <div style={AppStyle.wrapper}>
          <LoginPage preferences={preferences} />
        </div>
      );
    } else if (observeForAuthStatus.isSuccess) {
      return (
        <CmsApp
          user={user}
          preferences={preferences}
        >
          {children}
        </CmsApp>
      );
    }
    return null;
  },
);

class App extends Component {
  render() {
    return (
      <MuiThemeProvider muiTheme={getMuiTheme(muiTheme)}>
        <CmsWrapper>
          {this.props.children}
          <SnackBar />
        </CmsWrapper>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js